import ApiService from './ApiService'

const service = new ApiService('all', 'atendimentostotais')

export default {
  index: (pesquisa) => service.index(pesquisa),
  show: (id) => service.show(id),
  get: (id, pesquisa) => service.get(id, pesquisa),
  create: (data) => service.create(data),
  update: (id, data) => service.update(id, data),
  save: (data) => service.save(data)

}



// WEBPACK FOOTER //
// ./src/services/ListaFinanceiroService.js